import { Injectable } from "@angular/core";
import { JSONRpcDatabaseService, JSONRpcResponse, JSONRpcValidResponse } from "@app/shared/databases/json-rpc-database";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ClareHomeRPCMethodNames, ClareHomeRPCServiceNames } from "../ClareHomeRpc.constants";

@Injectable({
    providedIn: "root",
})
export class EquatorProxyService {
    constructor(private jsonRpcDatabaseService: JSONRpcDatabaseService) {}

    public makeClareHomeRpcRequest$(
        uuid: string,
        service: ClareHomeRPCServiceNames,
        method: ClareHomeRPCMethodNames,
        params: any[] = []
    ): Observable<any> {
        return this.jsonRpcDatabaseService
            .makeJSONRpcRequest$(uuid, `${service}/${method}`, params)
            .pipe(map((payload: JSONRpcResponse) => this.checkForErrors(payload, params)));
    }

    public makeSecureClareHomeRpcRequest$(
        uuid: string,
        service: ClareHomeRPCServiceNames,
        method: ClareHomeRPCMethodNames,
        params: any[] = []
    ): Observable<any> {
        return this.jsonRpcDatabaseService
            .makeSecureJSONRpcRequest$(uuid, `${service || ""}/${method || ""}`, params)
            .pipe(map((payload: JSONRpcResponse) => this.checkForErrors(payload, params)));
    }

    private isValidResponse(response: JSONRpcResponse): response is JSONRpcValidResponse {
        return response?.hasOwnProperty("result");
    }

    private checkForErrors(payload: JSONRpcResponse, params: any[]): DataServiceError<any> | Record<string, any> {
        const err = payload || { error: { message: "no result was returned" } };
        if (this.isValidResponse(payload)) {
            return payload.result;
        }

        return DataServiceError.throwNonObservableError<any[]>(params)(err);
    }
}
